import React from 'react';
import { connect } from 'react-redux';
import { colors, yaxis_count } from '../../../../constants';
import { getXaxisCategories } from '../../../../utils';
import GeneralChart from "./GeneralChart.jsx";

class TicketCountProgressOverTimeContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            agentSurveyCountVisibility: true,
            customerSurveyCountVisibility: true,
            ticketCountVisibility: true,
            //complianceVisibility: false,
        };
        this.toggleDataSeries = this.toggleDataSeries.bind(this);
    }

    toggleDataSeries(e) {
        if (e.dataSeries.name === "Agent Predictions") {
            this.setState({ agentSurveyCountVisibility: !this.state.agentSurveyCountVisibility });
        }
        else if (e.dataSeries.name === "Customer Survey") {
            this.setState({ customerSurveyCountVisibility: !this.state.customerSurveyCountVisibility });
        }
        else if (e.dataSeries.name === "All Tickets") {
            this.setState({ ticketCountVisibility: !this.state.ticketCountVisibility });
        }
        //else if (e.dataSeries.name === "Compliance") {
        //    this.setState({ complianceVisibility: !this.state.complianceVisibility });
        //}
    }

    render() {
        const { ticketCountOverTimeStats } = this.props;

        if (!ticketCountOverTimeStats || !Array.isArray(ticketCountOverTimeStats)) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;
        }
        else if (ticketCountOverTimeStats.length == 0) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                No data for the selected filters
            </div>;
        }

        const emptyDataPoint = ticketCountOverTimeStats.map(t => {
            return {
                label: t.windowStart.slice(0, 5),
                y: undefined
            }
        });

        const agentSurveyCountDataPoints = ticketCountOverTimeStats.map(t => {
            return {
                label: t.windowStart.slice(0, 5),
                y: t.agentSurveys
            }
        });

        const customerSurveyCountDataPoints = ticketCountOverTimeStats.map(t => {
            return {
                label: t.windowStart.slice(0, 5),
                y: t.customerSurveys
            }
        });

        const ticketCountDataPoints = ticketCountOverTimeStats.map(t => {
            return {
                label: t.windowStart.slice(0, 5),
                y: t.tickets
            }
        });

        //const compliance = {
        //    type: "column",
        //    color: '#E4D6F5',
        //    name: "Compliance",
        //    showInLegend: true,
        //    dataPoints: this.state.complianceVisibility ? complianceDataPoints : emptyDataPoint
        //};

        const agentSurveyCount = {
            type: "spline",
            color: colors.primary200,
            name: "Agent Predictions",
            showInLegend: true,
            dataPoints: this.state.agentSurveyCountVisibility ? agentSurveyCountDataPoints : emptyDataPoint
        };

        const customerSurveyCount = {
            type: "spline",
            color: colors.fourth200,
            name: "Customer Survey",
            showInLegend: true,
            dataPoints: this.state.customerSurveyCountVisibility ? customerSurveyCountDataPoints : emptyDataPoint
        };

        const ticketCount = {
            type: "spline",
            color: colors.secandary200,
            name: "All Tickets",
            showInLegend: true,
            dataPoints: this.state.ticketCountVisibility ? ticketCountDataPoints : emptyDataPoint
        };

        const data = [ticketCount,
            agentSurveyCount,
            customerSurveyCount
        ];

        return (
            <>
                <GeneralChart
                    yAxis={yaxis_count}
                    series={data}
                    showLegends={true}
                    xAxisCategories={[...getXaxisCategories(data)]}
                />
            </>
        );
    }
}

const select = state => ({});

export default connect(select)(TicketCountProgressOverTimeContainer);